export default {"src":"/_next/static/media/ic-bookmark.b532124e.svg","height":15,"width":12};